import Sidebar from "./Sidebar";
import GlobalLoadingBar from "./GlobalLoadingBar";
import { Toaster } from "./ui/sonner";

export default function AppShell({ children }) {
    return (
        <div className="flex min-h-screen bg-zinc-50 text-zinc-900">
            <GlobalLoadingBar />
            <Sidebar />
            <main className="flex-1 min-w-0 grid-bg">
                <div className="max-w-[1500px] mx-auto px-6 lg:px-10 py-8 fade-in">
                    {children}
                </div>
            </main>
            <Toaster richColors theme="dark" position="top-right" />
        </div>
    );
}
